var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99291 20.5V19H11.5507V15.573C10.702 15.4025 9.95199 15.0455 9.30066 14.502C8.64933 13.9583 8.18649 13.2808 7.91216 12.4692C6.75833 12.3321 5.78466 11.8423 4.99116 11C4.19749 10.1577 3.80066 9.15767 3.80066 8V7C3.80066 6.591 3.94841 6.23875 4.24391 5.94325C4.53941 5.64775 4.89166 5.5 5.30066 5.5H7.62766V3.5H16.9737V5.5H19.3007C19.7097 5.5 20.0619 5.64775 20.3574 5.94325C20.6529 6.23875 20.8007 6.591 20.8007 7V8C20.8007 9.15767 20.4038 10.1577 19.6102 11C18.8167 11.8423 17.843 12.3321 16.6892 12.4692C16.4148 13.2808 15.952 13.9583 15.3007 14.502C14.6493 15.0455 13.8993 15.4025 13.0507 15.573V19H16.6084V20.5H7.99291ZM7.62766 10.8577V7H5.30066V8C5.30066 8.6975 5.51924 9.31 5.95641 9.8375C6.39358 10.365 6.95066 10.7051 7.62766 10.8577ZM12.3007 14.1348C13.1788 14.1348 13.924 13.8286 14.5362 13.2163C15.1483 12.6041 15.4544 11.8589 15.4544 10.9807V5H9.14691V10.9807C9.14691 11.8589 9.45299 12.6041 10.0652 13.2163C10.6773 13.8286 11.4225 14.1348 12.3007 14.1348ZM16.9737 10.8577C17.6507 10.7051 18.2077 10.365 18.6449 9.8375C19.0821 9.31 19.3007 8.6975 19.3007 8V7H16.9737V10.8577Z",
    fill: "#5D5D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.b4031b6be5380e62b2f680b2d1da3987.svg";
export { ForwardRef as ReactComponent };